import React from "react";
import "../Styles/App.css";

const AboutView = () => (
  <div className="about-container">
    <header>
      <h1>About Akhil Patil Bagili</h1>
      <p>
        Hello! I'm Akhil, and first off, thank you for visiting my website. Born and raised in India, I've since made San Jose my home, where I pursued my passion for computer science at San Jose State University. My friends describe me as honest and witty, and that's a description I proudly wear. Let me share a little more about the person behind the code.
      </p>
    </header>
    
    <main>
      <p>
        From a young age, programming languages intrigued me. The thrill of typing lines of code and then seeing them spring to life is unmatched. And while coding is my first love, I have other interests that make me who I am. When I'm not working or studying, I often find myself immersed in podcasts or gaming.
      </p>
      <p>
        My aspirations extend beyond just coding. I envision building full-stack applications that bring about transformative changes in the tech industry. Incorporating Artificial Intelligence is definitely on my radar because, as I see it, the future is AI.
      </p>
    </main>
    
    <footer>
      <p>
        So, that's a little about me, beyond the codes and algorithms. If you'd like to connect, discuss projects, or even talk about the latest online game, don't hesitate to reach out!
      </p>
    </footer>
  </div>
);

export default AboutView;
